import lib from "./../../js-lib/lib.js";
import cacher from "./../../js-lib/cacher.js";
import toggler from "./../../js-lib/toggler.js";
import Fonts from "./Fonts.js";
import Stylesheet from "./Stylesheet.js";
import Theme from "./Theme.js";

const Eco = {
  load_cache: (state) => {
    // Load Eco Cache
    state["eco"] = cacher.retrieve("eco") ? cacher.retrieve("eco") : state.eco;
  },
  on: (state) => {
    toggler.on(lib.qsa(".global-js--eco-off"), state.eco);
    Eco.render(state);
    Theme.ecoOff(state);
    state.refresh = true;
  },
  off: (state) => {
    toggler.off(lib.qsa(".global-js--eco-on"), state.eco);
    Eco.render(state);
    Theme.ecoOff(state);
    state.refresh = true;
  },
  themeOff: (state) => {
    // Used when the theme is switching
    toggler.off(lib.qsa(".global-js--eco-on"), state.eco);
    Eco.render(state);
  },
  global_scope: (state, callback = null) => {
    lib.qsa(".global-js--eco-off").forEach((elem) => {
      elem.addEventListener("click", (e) => {
        Eco.off(state);
        callback(state);
      });
    });

    lib.qsa(".global-js--eco-on").forEach((elem) => {
      elem.addEventListener("click", (e) => {
        Eco.on(state);
        callback(state);
      });
    });
  },
  scope: (state) => {},
  render: (state) => {
    // Render Eco Off / On States
    toggler.render(lib.qsa(".global-js--eco-on"), state.eco);
    toggler.render(lib.qsa(".global-js--eco-off"), state.eco);
    cacher.store("eco", state.eco);
    Fonts.render(state);
    Stylesheet.render(state);
  },
};

export { Eco as default };
